import React from 'react';
import './App.css';
import BabyNameFiles from './Components/babyNameFiles.js'

function App() {
  return (
    <BabyNameFiles />
  );
}

export default App;
